/**
 * Event bus implementation.
 * 
 * @since 1.0.0
 * @package dealerkit-wp
 */
export class EventBus {

    constructor() {
        this.bus =  document.createElement('div')
    }

    on(event, callback) {
        if (event === 'loaded' && document.readyState === 'complete') {
            callback.call()
            return
        }

        this.bus.addEventListener(event, callback)
    }

    off(event, callback) {
        this.bus.removeEventListener(event, callback)
    }

    emit(event, payload = {}) {
        this.bus.dispatchEvent(new CustomEvent(event, {
            detail: payload
        }))
    }

}